// removed by extract-text-webpack-plugin
module.exports = {"input":"file-input--input---9Hd8Rzr","browse":"file-input--browse--32tD3u-N","hover":"file-input--hover--1FAH3-eo","disabled":"file-input--disabled--6G8pRvU0","list":"file-input--list--3BsKyHpM","remove":"file-input--remove--146NiRxW"};


//////////////////
// WEBPACK FOOTER
// ./components/forms/file-input/styles.css
// module id = ./components/forms/file-input/styles.css
// module chunks = 0